import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=271edc0f&scoped=true&"
import script from "./BaseInput.vue?vue&type=script&lang=js&"
export * from "./BaseInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseInput.vue?vue&type=style&index=0&id=271edc0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271edc0f",
  null
  
)

export default component.exports